import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// components
import HearroCommonTable from "../../table/HearroCommonTable";
import CommonPagination from '../../../pagination/CommonPagination';

// api
import { getGameListFromHearro, getPatientLastWeekFromHearro, getTrainCountAmountScoreFromHearro, getTrainHistoryFromHearro } from "../../../../services/apis/hearro/train";


const tableHeader = [
    {
        key: 'trainName',
        value: '게임명'
    },
    {
        key: 'amount',
        value: '게임 학습량(분 단위)'
    },
    {
        key: 'level',
        value: '레벨'
    },
    {
        key: 'date',
        value: '날짜'
    },
    {
        key: 'score',
        value: '점수'
    }
]

const dayList = ['월', '화', '수', '목', '금', '토', '일'];

function HearroGame() {
    const { pid } = useParams();
    // 선택한 게임 code (전체는 "0000")
    const [selectedGameCode, setSelectedGameCode] = useState('0000');
    // 선택한 날짜 형식 (주별/월별)
    const [selectedDateType, setSelectedDateType] = useState("주별");
    // 선택한 게임 레벨 (전체/1/2/3)
    const [selectedGameScoreLevel, setSelectedGameScoreLevel] = useState("전체");

    // 게임 버튼 리스트
    const [gameList, setGameList] = useState([]);

    // 사용 시간 및 횟수 & 게임 평균 점수 리스트
    const [trainAmountCountScoreList, setTrainAmountCountScoreList] = useState([]);

    // 최대 사용 시간
    const [maxGameTime, setMaxGameTime] = useState(0);
    // 최고 점수
    const [maxGameScore, setMaxGameScore] = useState(0);

    // 그래프 호버 시 나타나는 요소 좌표 & 최고/최저 점수
    const [hoverPos, setHoverPos] = useState({ x: 0, y: 0 });
    const [hoverMaxScore, setHoverMaxScore] = useState(0);
    const [hoverMinScore, setHoverMinScore] = useState(0);

    // 게임 이력 table
    const [trainHistoryList, setTrainHistoryList] = useState([]);
    const [tablePageCnt, setTablePageCnt] = useState(1);
    const [selectedPage, setSelectedPage] = useState(1);

    // 선택한 기간
    // 0은 현재 달, 1은 1달 전
    const [selectedMonthAgo, setSelectedMonthAge] = useState(0);
    // 결과보기 탭처럼 어플 시작 날짜 기준 주차
    const [selectedWeek, setSelectedWeek] = useState(0);
    // 환자의 최근 주차
    const [lastWeek, setLastWeek] = useState(0);


    // GET 게임 리스트 from API
    async function getGameListFromAPI() {
        try{
            const res = await getGameListFromHearro();
            if(parseInt(res.status/200,10)===1){
                setGameList(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setGameList([]);
        }
    }

   // GET 환자의 최근 주차 from API
    async function getLastWeekFromAPI() {
        try {
            const res = await getPatientLastWeekFromHearro({ pid });
            if(parseInt(res.status/200,10)===1){
                if(res.data){
                    setLastWeek(res.data);
                    setSelectedWeek(res.data);
                }else{
                    setLastWeek(1);
                    setSelectedWeek(1);
                }                
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setLastWeek(1);
            setSelectedWeek(1);
        }
    }

    // GET 게임별 이력 리스트 from API
    async function getTrainHistoryListFromAPI(page) {
        try{
            const request = {
                pid,
                trainId: selectedGameCode,
                page
            };
            if(selectedDateType==="주별"){
                request.week = selectedWeek;
            }else{
                request.month = selectedMonthAgo;
            }
            const res = await getTrainHistoryFromHearro(request);
            if(parseInt(res.status/200,10)===1){
                const newTrainHistoryList = res.data.map(e=>{
                    if(e.date.length>=8){
                        return {...e, amount: `${e.amount} 분`, date: `${e.date.slice(0,4)}-${e.date.slice(4,6)}-${e.date.slice(6)}`}
                    }else{
                        return {...e, amount: `${e.amount} 분`};
                    }                    
                })
                setTrainHistoryList(newTrainHistoryList);
                if(res.data.length>0){
                    setTablePageCnt(Math.ceil(res.data[0].totalCnt/10));
                }else{
                    setTablePageCnt(1);
                }             
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setTrainHistoryList([]);
            setTablePageCnt(1);
        }
    }

    // GET 사용 시간 및 횟수 & 게임 평균 점수 from API
    async function getTrainAmountCountAvgScoreFromAPI() {
        try{
            const request = {
                pid,
                trainId: selectedGameCode,
            };
            if(selectedDateType==="주별"){
                request.week = selectedWeek;
            }else{
                request.month = selectedMonthAgo;
            }
            const res = await getTrainCountAmountScoreFromHearro(request);
            if(parseInt(res.status/200,10)===1){
                const newTrainAmountCountScoreList = res.data.map(e=> {
                    const newObj = {...e};
                    if(!e.amount) {
                        newObj.amount = 0;
                    }
                    if(!e.count) {
                        newObj.count = 0;
                    }
                    if(e.levelScore){
                        newObj.levelScore = JSON.parse(e.levelScore);
                    }else{
                        newObj.levelScore = [];
                    }

                    return newObj;
                })
                setTrainAmountCountScoreList(newTrainAmountCountScoreList);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setTrainAmountCountScoreList([]);
        }
    }


    function handleGraphBarMouseEnter(e, maxScore, minScore) {
        setHoverMaxScore(maxScore);
        setHoverMinScore(minScore);
        const targetPos = e.target.getBoundingClientRect();
        setHoverPos({x: targetPos.x, y: targetPos.y});
    }

    const getNewTableDataByPagination = (curPage) => {
        getTrainHistoryListFromAPI(curPage);
    }

    function handleClickMovePrevDate() {
        if(selectedDateType==="주별") {
            setSelectedWeek(selectedWeek-1);
        }else if(selectedDateType==="월별"){
            setSelectedMonthAge(selectedMonthAgo+1);
        }
    }

    function handleClickMoveNextDate() {
        if(selectedDateType==="주별"){
            setSelectedWeek(selectedWeek+1);
        }else if(selectedDateType==="월별"){
            setSelectedMonthAge(selectedMonthAgo-1);
        }
    }

    // selectedMonthAge로 현재 선택된 달을 출력
    function printSelectedMonth() {
        const curDate = new Date();
        curDate.setMonth(curDate.getMonth()-selectedMonthAgo);
        return curDate.getMonth()+1;
    }

    useEffect(()=>{
        getGameListFromAPI();
        getLastWeekFromAPI();
    },[])

    useEffect(()=>{
        setSelectedPage(1);
        getTrainHistoryListFromAPI(1);
        getTrainAmountCountAvgScoreFromAPI();
    },[selectedGameCode, selectedDateType, selectedMonthAgo, selectedWeek])

    useEffect(()=>{
        // 최대 사용 시간 구하기
        const timeList = trainAmountCountScoreList.map(e=>e.amount);
        if(timeList.length>0){
            const newMaxGameTime = Math.max(...timeList);
            setMaxGameTime(newMaxGameTime);
        }else{
            setMaxGameTime(0);
        }
    },[trainAmountCountScoreList])

    useEffect(()=>{
        // 최고 점수, 최저 점수 구하기
        const scoreList = [];
        trainAmountCountScoreList.forEach(e=>{
            if(e.levelScore){
                scoreList.push(...e.levelScore.filter(el=>selectedGameScoreLevel==="전체" || el.level.toString()===selectedGameScoreLevel).map(el=>el.avg_score))
            }
            
        });
        if(scoreList.length>0){
            const newMaxGameScore = Math.max(...scoreList);
            setMaxGameScore(newMaxGameScore);
        }else{
            setMaxGameScore(0);
        }
    },[trainAmountCountScoreList, selectedGameScoreLevel])

    return (
        <div className="paitentResult__gameArea">
            <div className="button_wrapper_game_type">
                <button
                    className={`${selectedGameCode==='0000' ? "selected" : ""}`}
                    onClick={()=>setSelectedGameCode('0000')}
                >전체</button>
                {gameList.map(e=>(
                    <button
                        key={e.code}
                        className={`${selectedGameCode===e.code ? "selected" : ""}`}
                        onClick={()=>setSelectedGameCode(e.code)}
                    >
                        {e.nameKr}
                    </button>
                ))}
            </div>
            <div className="graph_box">
                <div className="graph_box_header">
                    <div className="graph_box_date_wrapper">
                        <button
                            onClick={((selectedDateType==="주별" && selectedWeek>1) || selectedDateType==="월별") ? handleClickMovePrevDate : null}
                            style={{cursor: ((selectedDateType==="주별" && selectedWeek>1) || selectedDateType==="월별") ? "pointer" : "default"}}
                        >&lt;</button>
                        <span className="date_title">
                            {selectedDateType==="주별" ? ` ${selectedWeek}주차` : `${printSelectedMonth()}월`}
                        </span>
                        <button
                            onClick={((selectedDateType==="주별" && selectedWeek<lastWeek) || (selectedDateType==="월별" && selectedMonthAgo>0)) ? handleClickMoveNextDate : null}
                            style={{cursor: (selectedDateType==="주별" && selectedWeek<lastWeek) || (selectedDateType==="월별" && selectedMonthAgo>0) ? "pointer" : "default"}}
                        >&gt;</button>
                    </div>
                    <div className="graph_box_btn_wrapper">
                        <button
                            className={`${selectedDateType==="주별" ? "selected" : ""}`}
                            onClick={()=>{
                                setSelectedDateType("주별");
                            }}
                        >주별</button>
                        <button
                            className={`${selectedDateType==="월별" ? "selected" : ""}`}
                            onClick={()=>{
                                setSelectedDateType("월별");
                            }}
                        >월별</button>
                    </div>              
                </div>
                <div className="graph_box_content">
                    <div className="graph_wrapper">
                        <div className="graph_header">
                            <div className="graph_legend">
                                <div className="graph_legend_icon"/>
                                <span>권장 사용 시간</span>
                            </div>
                            <div className="graph_title">사용 시간 및 횟수</div>
                        </div>
                        <div className="graph">
                            <div className="graph_y_axis">
                                <div className="graph_y_axis_label" style={{ bottom: maxGameTime > 30 ? `${30/maxGameTime * 100}%` : '100%', color: '#174A84', fontWeight: 'bold'}}>30 분</div>
                                <div className="graph_y_axis_label" style={{ bottom: 0 }}>0 분</div>
                            </div>
                            <div className="graph_right_section">
                                <div className="graph_item_wrapper">
                                    {trainAmountCountScoreList.map(e=>(
                                        <div key={e.date} className="graph_item">
                                            <div className="graph_bar_with_label">
                                                {e.count>0 && (
                                                    <div
                                                        className="graph_floating_label"
                                                        style={{ bottom: maxGameTime > 30 ? `${e.amount/maxGameTime * 100}%` : `${e.amount/30 * 100}%`}}
                                                    >{e.count}</div>
                                                )}
                                                <div
                                                    className="graph_item_bar"
                                                    style={{ height: maxGameTime > 30 ? `${e.amount/maxGameTime * 100}%` : `${e.amount/30 * 100}%`}}
                                                />
                                            </div>   
                                        </div>
                                    ))}
                                    <div className="graph_30_min_line" style={{ bottom: maxGameTime > 30 ? `${30/maxGameTime * 100}%` : '', top: maxGameTime > 30 ? "" : "0"}} />
                                </div>
                                <div className="graph_x_axis_label">
                                    {trainAmountCountScoreList.map(e=>(
                                        <div key={e.date} className="graph_x_item">{Number(e.date.slice(6))}/{dayList[e.dayOfWeek-1]}</div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="graph_wrapper">
                        {hoverPos.x!==0 && hoverPos.y!==0 && (
                            <div
                                className="graph_hover_item"
                                style={{ top: `${hoverPos.y}px`, left: `calc(${hoverPos.x}px + 0.3125rem)`}}
                            >
                                <p><span>최고 점수</span>&nbsp;&nbsp;{hoverMaxScore}점<br/><span>최저 점수</span>&nbsp;&nbsp;{hoverMinScore}점</p>
                            </div>
                        )}
                        <div className="graph_header">
                            <div className="graph_title">게임 평균 점수</div>
                            <select
                                onChange={(e) => setSelectedGameScoreLevel(e.target.value)}
                                value={selectedGameScoreLevel}
                            >
                                <option>전체</option>
                                <option value={1}>레벨 1</option>
                                <option value={2}>레벨 2</option>
                                <option value={3}>레벨 3</option>
                            </select>
                        </div>
                        <div className="graph">
                            <div className="graph_y_axis">
                                <div className="graph_y_label_wrapper">
                                    <div className="graph_y_label_item">
                                        <div className="graph_y_label_item_icon" style={{ backgroundColor: '#AFD0DB' }} />
                                        <span>레벨 1</span>
                                    </div>
                                    <div className="graph_y_label_item">
                                        <div className="graph_y_label_item_icon" style={{ backgroundColor: '#6098AB' }} />
                                        <span>레벨 2</span>
                                    </div>
                                    <div className="graph_y_label_item">
                                        <div className="graph_y_label_item_icon" style={{ backgroundColor: '#315663' }} />
                                        <span>레벨 3</span>
                                    </div>
                                </div>
                            </div>
                            <div className="graph_right_section">
                                <div className="graph_item_wrapper">
                                    {trainAmountCountScoreList.map(e=>(
                                        <div key={e.date} className="graph_item">
                                            {e.levelScore.map(levelItem => (
                                                (selectedGameScoreLevel==="전체" || selectedGameScoreLevel===levelItem.level.toString()) && <div key={levelItem.level} className="graph_bar_with_label">
                                                <div
                                                    className="graph_floating_label"
                                                    style={{ bottom: `${levelItem.avg_score/maxGameScore * 100}%`}}
                                                >
                                                    {levelItem.avg_score}
                                                </div>
                                                <div
                                                    className={`graph_item_bar ${levelItem.level===2 ? "level2" : ""} ${levelItem.level===3 ? "level3" : ""}`}
                                                    style={{ height: `${levelItem.avg_score/maxGameScore * 100}%`}}
                                                    onMouseEnter={(mouseEvt)=>handleGraphBarMouseEnter(mouseEvt, levelItem.max_score, levelItem.min_score)}
                                                    onMouseLeave={()=>{
                                                        setHoverPos({ x: 0, y: 0})
                                                    }}
                                                />
                                            </div>
                                            ))}                
                                        </div>
                                    ))}
                                </div>
                                <div className="graph_x_axis_label">
                                    {trainAmountCountScoreList.map(e=>(
                                        <div key={e.date} className="graph_x_item">
                                            {Number(e.date.slice(6))}/{dayList[e.dayOfWeek-1]}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
            <div className="table_wrapper" style={{ padding: '0 6.25rem' }}>
                <HearroCommonTable
                    tableHeader={tableHeader}
                    tableBody={trainHistoryList}
                    pageCnt={selectedPage}
                />
                <CommonPagination
                    pageCnt={tablePageCnt}
                    selectedPage={selectedPage}
                    SetSelectedPage={setSelectedPage}
                    GetNewTableData={getNewTableDataByPagination}
                />
            </div>  
        </div>
    );
}

export default HearroGame;